module.exports = __webpack_public_path__ + "img/ic_alert_camera.cb44acdf.png";